import { useMutation } from '@tanstack/react-query';

const postSmsVerification = async (phoneNum) => {
  const response = await fetch(`/api/send-sms`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ phone: phoneNum }),
  });

  const data = await response.json();
  return { status: response.status, data };
};

function useVerificationSender({ setPageStep }) {
  const mutation = useMutation({
    mutationFn: postSmsVerification,
    onSuccess({ status }) {
      if (status >= 200 && status < 300) {
        setPageStep('showSmsVerification');
      }

      if (status >= 400 && status < 500) {
        setPageStep('fatalError');
      }

      if (status >= 500) {
        setPageStep('fatalError');
      }
    },
    onError() {
      setPageStep('fatalError');
    },
  });

  return {
    send(phoneNum) {
      mutation.mutate(phoneNum);
    },
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    isLoading: mutation.isPending,
  };
}

export default useVerificationSender;
